import React from "react";
import {
  Grid,
  Button,
} from "@mui/material";
import {
  makeStyles
} from "@mui/styles";
import {getImage} from "../../../../../utils/image";
import numberFormat from "../../../../../utils/numberFormat";
import rateConvert from "../../../../../utils/rateConvert";
import {useBuyNumber} from "../../../../../contexts/BuyNumberContext";
import getTrans from "../../../../../languages/getTrans";

const PopularCountries = ({ items }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.head}>
        <div className={classes.headIcon}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 9.75C8.85166 9.75 8.70666 9.70601 8.58332 9.6236C8.45999 9.54119 8.36386 9.42406 8.30709 9.28701C8.25032 9.14997 8.23547 8.99917 8.26441 8.85368C8.29335 8.7082 8.36478 8.57456 8.46967 8.46967C8.57456 8.36478 8.7082 8.29335 8.85368 8.26441C8.99917 8.23547 9.14997 8.25032 9.28701 8.30709C9.42406 8.36386 9.54119 8.45999 9.6236 8.58332C9.70601 8.70666 9.75 8.85166 9.75 9C9.75 9.19891 9.67098 9.38968 9.53033 9.53033C9.38968 9.67098 9.19891 9.75 9 9.75ZM15 14.25C14.8517 14.25 14.7067 14.294 14.5833 14.3764C14.46 14.4588 14.3639 14.5759 14.3071 14.713C14.2503 14.85 14.2355 15.0008 14.2644 15.1463C14.2934 15.2918 14.3648 15.4254 14.4697 15.5303C14.5746 15.6352 14.7082 15.7066 14.8537 15.7356C14.9992 15.7645 15.15 15.7497 15.287 15.6929C15.4241 15.6361 15.5412 15.54 15.6236 15.4167C15.706 15.2933 15.75 15.1483 15.75 15C15.75 14.8011 15.671 14.6103 15.5303 14.4697C15.3897 14.329 15.1989 14.25 15 14.25ZM22.5 12C22.5 12.9788 21.7959 13.7128 21.1744 14.3606C20.8209 14.73 20.4553 15.1106 20.3175 15.4453C20.19 15.7519 20.1825 16.26 20.175 16.7522C20.1609 17.6672 20.1459 18.7041 19.425 19.425C18.7041 20.1459 17.6672 20.1609 16.7522 20.175C16.26 20.1825 15.7519 20.19 15.4453 20.3175C15.1106 20.4553 14.73 20.8209 14.3606 21.1744C13.7128 21.7959 12.9788 22.5 12 22.5C11.0212 22.5 10.2872 21.7959 9.63937 21.1744C9.27 20.8209 8.88938 20.4553 8.55469 20.3175C8.24813 20.19 7.74 20.1825 7.24781 20.175C6.33281 20.1609 5.29594 20.1459 4.575 19.425C3.85406 18.7041 3.83906 17.6672 3.825 16.7522C3.8175 16.26 3.81 15.7519 3.6825 15.4453C3.54469 15.1106 3.17906 14.73 2.82562 14.3606C2.20406 13.7128 1.5 12.9788 1.5 12C1.5 11.0212 2.20406 10.2872 2.82562 9.63937C3.17906 9.27 3.54469 8.88938 3.6825 8.55469C3.81 8.24813 3.8175 7.74 3.825 7.24781C3.83906 6.33281 3.85406 5.29594 4.575 4.575C5.29594 3.85406 6.33281 3.83906 7.24781 3.825C7.74 3.8175 8.24813 3.81 8.55469 3.6825C8.88938 3.54469 9.27 3.17906 9.63937 2.82562C10.2872 2.20406 11.0212 1.5 12 1.5C12.9788 1.5 13.7128 2.20406 14.3606 2.82562C14.73 3.17906 15.1106 3.54469 15.4453 3.6825C15.7519 3.81 16.26 3.8175 16.7522 3.825C17.6672 3.83906 18.7041 3.85406 19.425 4.575C20.1459 5.29594 20.1609 6.33281 20.175 7.24781C20.1825 7.74 20.19 8.24813 20.3175 8.55469C20.4553 8.88938 20.8209 9.27 21.1744 9.63937C21.7959 10.2872 22.5 11.0212 22.5 12ZM9 11.25C9.44501 11.25 9.88002 11.118 10.25 10.8708C10.62 10.6236 10.9084 10.2722 11.0787 9.86104C11.249 9.4499 11.2936 8.9975 11.2068 8.56105C11.12 8.12459 10.9057 7.72368 10.591 7.40901C10.2763 7.09434 9.87541 6.88005 9.43895 6.79323C9.0025 6.70642 8.5501 6.75097 8.13896 6.92127C7.72783 7.09157 7.37643 7.37996 7.12919 7.74997C6.88196 8.11998 6.75 8.55499 6.75 9C6.75 9.59674 6.98705 10.169 7.40901 10.591C7.83097 11.0129 8.40326 11.25 9 11.25ZM16.2806 8.78063C16.3503 8.71094 16.4056 8.62822 16.4433 8.53717C16.481 8.44613 16.5004 8.34855 16.5004 8.25C16.5004 8.15145 16.481 8.05387 16.4433 7.96283C16.4056 7.87178 16.3503 7.78906 16.2806 7.71937C16.2109 7.64969 16.1282 7.59442 16.0372 7.5567C15.9461 7.51899 15.8485 7.49958 15.75 7.49958C15.6515 7.49958 15.5539 7.51899 15.4628 7.5567C15.3718 7.59442 15.2891 7.64969 15.2194 7.71937L7.71937 15.2194C7.64969 15.2891 7.59442 15.3718 7.5567 15.4628C7.51899 15.5539 7.49958 15.6515 7.49958 15.75C7.49958 15.8485 7.51899 15.9461 7.5567 16.0372C7.59442 16.1282 7.64969 16.2109 7.71937 16.2806C7.86011 16.4214 8.05098 16.5004 8.25 16.5004C8.34855 16.5004 8.44613 16.481 8.53717 16.4433C8.62822 16.4056 8.71094 16.3503 8.78063 16.2806L16.2806 8.78063ZM17.25 15C17.25 14.555 17.118 14.12 16.8708 13.75C16.6236 13.38 16.2722 13.0916 15.861 12.9213C15.4499 12.751 14.9975 12.7064 14.561 12.7932C14.1246 12.88 13.7237 13.0943 13.409 13.409C13.0943 13.7237 12.88 14.1246 12.7932 14.561C12.7064 14.9975 12.751 15.4499 12.9213 15.861C13.0916 16.2722 13.38 16.6236 13.75 16.8708C14.12 17.118 14.555 17.25 15 17.25C15.5967 17.25 16.169 17.0129 16.591 16.591C17.0129 16.169 17.25 15.5967 17.25 15Z" fill="#FB7800"/>
          </svg>
        </div>
        <div className={classes.headName}>{getTrans('popularCountries.Высокий % доставки')}</div>
      </div>
      <Grid container spacing={1}>
        {items.map((item, index) => (
          <Grid key={`item-${item.id}`} item xs={12}>
            <ActivationCard item={item}/>
          </Grid>
        ))}
      </Grid>
    </div>
  )
}
const ActivationCard = ({ item }) => {
  const classes = useStyles();
  const { handleOpenBuy } = useBuyNumber();
  const countPrint = `${numberFormat(item.count)} ${getTrans('common.шт')}`
  const pricePrint = `${rateConvert(item.price, {useSybmol: true, decimalCount: 'auto'})}`

  const handleBuyNumber = () => {
    handleOpenBuy({
      serviceSlug: item.service_slug,
      serviceExtraId: item.service_external_id,

      countryId: item.id,
      countrySlug: item.slug,
      countryExtraId: item.external_id,

      initPrice: null
    });
  }

  return (
    <Button className={classes.activationCard} onClick={handleBuyNumber}>
      <div className={classes.activationCardIcon}>
        <img src={getImage(item.icon_id, {width: 32, height: 32})}/>
      </div>
      <div className={classes.activationCardName}>{item.name}</div>
      <div className={classes.activationCardCount}>{countPrint}</div>
      <div className={classes.activationCardBuy}>
        {pricePrint}
      </div>
    </Button>
  )
}

const useStyles = makeStyles(theme => ({
  root: {
    padding: "10px",
    borderRadius: "12px",
    background: '#0F191F',
    boxSizing: "border-box",
    border: "1px solid #FFFFFF1A",
  },

  head: {
    gap: "8px",
    display: "flex",
    marginBottom: "6px",
    alignItems: "center",
  },
  headName: {
    marginTop: "-4px",
    fontSize: 18,
    fontWeight: "500",
    lineHeight: "22px",
    color: theme.palette.text.primary,
  },

  activationCard: {
    width: "100%",
    height: "40px",
    display: "flex",
    padding: "0 4px",
    borderRadius: "12px",
    alignItems: "center",
    justifyContent: "flex-start",
    background: "#24323A!important"
  },
  activationCardIcon: {
    width: 32,
    height: 32,
    minWidth: 32,
    display: "flex",
    marginRight: "8px",
    overflow: "hidden",
    borderRadius: "8px",
    alignItems: "center",
    position: "relative",
    justifyContent: "center",
    "& img": {
      width: "100%",
      height: "100%",
      objectFit: "cover",
      objectPosition: "50% 50%",
    }
  },
  activationCardName: {
    flex: "auto",

    fontSize: 16,
    textAlign: "left",
    fontWeight: "500",
    lineHeight: "20px",
    color: theme.palette.text.primary,

    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  activationCardCount: {
    whiteSpace: 'nowrap',
  },
  activationCardBuy: {
    height: "32px",
    display: "flex",
    minWidth: "64px",
    padding: "0 6px",
    marginLeft: "8px",
    borderRadius: "8px",
    alignItems: "center",
    background: "#FB7800",
    boxSizing: "border-box",
    justifyContent: "flex-start",

    color: "white",
    fontSize: "13px",
    fontWeight: "500",
    lineHeight: "16px",
  },
}));

export default PopularCountries
